import { render, staticRenderFns } from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=template&id=a69bdd78&"
import script from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailsTemplatesWarningEditionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports